import FormGroup from '@/ui-kit/components/form/entities/FormGroup';
import FormControl from '@/ui-kit/components/form/entities/FormControl';
import {
  requiredFormValidator,
  getMinLengthFormValidator,
  getMaxLengthFormValidator,
  caseInsensitiveEmailFormValidator,
} from '@/ui-kit/components/form/validators';
import { FormControlValidationStrategy } from '@/ui-kit/components/form/entities/enums';
import { AuthSignupFormControlName } from '../enums';
import { AUTH_SIGNUP_FORM_DEFAULT_VALUE } from '../constants';
import {
  DEFAULT_MAX_PASSWORD_LENGTH,
  DEFAULT_MIN_PASSWORD_LENGTH,
  PASSWORD_MAX_LENGTH_ERROR_MESSAGE,
  PASSWORD_MIN_LENGTH_ERROR_MESSAGE,
} from '../../../constants';

export const passwordMinLengthValidator = getMinLengthFormValidator(
  DEFAULT_MIN_PASSWORD_LENGTH, PASSWORD_MIN_LENGTH_ERROR_MESSAGE,
);
export const passwordMaxLengthValidator = getMaxLengthFormValidator(
  DEFAULT_MAX_PASSWORD_LENGTH, PASSWORD_MAX_LENGTH_ERROR_MESSAGE,
);

export const firstNameFormControl = new FormControl(
  AUTH_SIGNUP_FORM_DEFAULT_VALUE[AuthSignupFormControlName.FirstName],
  [requiredFormValidator],
);

export const lastNameFormControl = new FormControl(
  AUTH_SIGNUP_FORM_DEFAULT_VALUE[AuthSignupFormControlName.LastName],
  [requiredFormValidator],
);

export const emailFormControl = new FormControl(
  AUTH_SIGNUP_FORM_DEFAULT_VALUE[AuthSignupFormControlName.Email],
  [requiredFormValidator, caseInsensitiveEmailFormValidator],
);

export const passwordFormControl = new FormControl(
  AUTH_SIGNUP_FORM_DEFAULT_VALUE[AuthSignupFormControlName.Password],
  [requiredFormValidator, passwordMinLengthValidator, passwordMaxLengthValidator],
);

export const authSignupFormGroup = new FormGroup(
  {
    [AuthSignupFormControlName.FirstName]: firstNameFormControl,
    [AuthSignupFormControlName.LastName]: lastNameFormControl,
    [AuthSignupFormControlName.Email]: emailFormControl,
    [AuthSignupFormControlName.Password]: passwordFormControl,
  },
  [FormControlValidationStrategy.Change, FormControlValidationStrategy.Blur],
);
